import store, { persistor } from '@/store/store'
import {
  AuthenticationResult,
  EventMessage,
  EventType,
} from '@azure/msal-browser'
import { AllCommunityModule, ModuleRegistry } from 'ag-grid-community'
import ChartJS from 'chart.js/auto'
import 'chartjs-adapter-date-fns'
import annotationPlugin from 'chartjs-plugin-annotation'
import datalabelsPlugin from 'chartjs-plugin-datalabels'
import mixpanel from 'mixpanel-browser'
import ReactDOM from 'react-dom/client'
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'
import App from './App'
import './i18n'
import './main.css'
import { msalInstance } from './services/msalInstance'
import { analytics } from './utils/analytics'

ChartJS.register(datalabelsPlugin, annotationPlugin)

ModuleRegistry.registerModules([AllCommunityModule])

const mixpanelToken = import.meta.env.VITE_MIXPANEL_TOKEN

if (mixpanelToken) {
  mixpanel.init(mixpanelToken, {
    debug: false,
    autocapture: true,
    record_sessions_percent: 100,
    ignore_dnt: true,
  })

  analytics.setInitialized()
} else {
  console.warn('Mixpanel token not found in environment variables')
}

const initializeMsal = async () => {
  await msalInstance.initialize()

  msalInstance.addEventCallback((event: EventMessage) => {
    if (
      (event.eventType === EventType.LOGIN_SUCCESS ||
        event.eventType === EventType.HANDLE_REDIRECT_END) &&
      event.payload
    ) {
      const payload = event.payload as AuthenticationResult
      const account = payload.account
      msalInstance.setActiveAccount(account)

      try {
        if (mixpanel && account.localAccountId) {
          mixpanel.identify(account.localAccountId)
          const email = account.idTokenClaims?.email as string | undefined
          if (email) {
            mixpanel.people.set({
              email: email.toLowerCase(),
              name: account.name,
            })
          }
        }
      } catch (error) {
        console.error('Error setting Mixpanel identity:', error)
      }
    }
  })

  const accounts = msalInstance.getAllAccounts()
  if (accounts.length > 0) {
    msalInstance.setActiveAccount(accounts[0])
  }

  const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
  )

  root.render(
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <App instance={msalInstance} />
      </PersistGate>
    </Provider>
  )
}

initializeMsal().catch((error) => {
  console.error('Error initializing MSAL:', error)
})
